const state = {
  areaValue: []
};

const getters = {
  getAreaValue: (state) => state.areaValue
};

const actions = {
  setAreaValueAsync({ commit }, routes) {
    commit("setAreaValue", routes);
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: {
    setAreaValue(state, value) {
      state.areaValue = value;
    }
  }
};
